import { Tooltip, Typography } from "@mui/material";
import { getColorStatus } from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/const";
import { statusConfirmOption } from "modules/DeclareLeave/components/CustomCalendarTimeKeeping/const";
import { listTimeKeepingManagerSelector } from "modules/DeclareLeave/redux/selector";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import pxToRem from "theme/base/pxToRem";
import { BoxCol, TextCenter } from "./styles";
import { themesSelector } from "theme/selector";

export enum STATUS_TIME_KEEPING {}

const useColumns = () => {
  const data = useSelector(listTimeKeepingManagerSelector);
  const { isMiniWindow } = useSelector(themesSelector);

  const listHeaderPlus = useMemo(() => {
    if (!data && !data?.length) return [];
    if (!data[0]!?.leaveReasons && !data[0]!?.leaveReasons?.length) return [];
    return data[0]!?.leaveReasons?.map((it, idx) => ({
      id: it?.reasonCode,
      accessorKey: it?.reasonCode,
      header: (
        <Typography sx={{ textAlign: "center" }}>{it?.reasonCode}</Typography>
      ),
      width: 90,
      minSize: 90,
      cell: (info) => (
        <Typography
          sx={(theme) => ({
            fontSize: pxToRem(12),
            color: theme.palette.text.textPrimary,
            width: "100%",
            textAlign: "center",
            textWrap: "wrap",
            whiteSpace: "wrap",
            textOverflow: "hidden",
          })}
        >
          {info?.row?.original?.leaveReasons[idx]?.totalDays}
        </Typography>
      ),
      footer: (props) => props.column.id,
      pinPosition: "left",
      headerStyle: {
        padding: 0,
        display: "flex",
        justifyContent: "center",
      },
      customStyle: {
        justifyContent: "center",
      },
      enableSorting: false,
    }));
  }, [data]);

  const columns = useMemo(() => {
    const cols: any[] = [
      {
        id: "employeeCode",
        accessorKey: "employeeCode",
        header: "Mã NV",
        footer: (props) => props.column.id,
        minSize: 120,
        pinPosition: "left",
        enableSorting: false,
      },
      {
        id: "employeeName",
        accessorKey: "employeeName",
        header: "Tên nhân viên",
        minSize: 150,
        pinPosition: "left",
        enableSorting: false,
      },
      {
        id: "positionName",
        accessorKey: "positionName",
        header: "Chức danh",
        minSize: 150,
        pinPosition: "left",
        enableSorting: false,
      },
      {
        id: "departmentName",
        accessorKey: "departmentName",
        header: "Đơn vị",
        footer: (props) => props.column.id,
        minSize: 150,
        pinPosition: "left",
        enableSorting: false,
      },
      {
        minSize: isMiniWindow ? 50 : 150,
        id: "totalWorkDays",
        accessorKey: "totalWorkDays",
        header: (
          <Tooltip title="Tổng số ngày công tính lương nhân sự">
            <Typography
              sx={(theme) => ({
                fontSize: pxToRem(14),
                [theme.breakpoints.down("lg")]: {
                  fontSize: pxToRem(12),
                  textAlign: "center",
                  width: pxToRem(50),
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                },
              })}
            >
              TỔNG CỘNG NGÀY CÔNG TÍNH LƯƠNG NS
            </Typography>
          </Tooltip>
        ),
        width: 0,
        right: isMiniWindow ? 60 : 150,
        cell: (info) => (
          <BoxCol>
            <TextCenter
              sx={(theme) => ({
                color: theme.palette.colorsBase.blue_0,
              })}
            >
              {info?.getValue() || 0}
            </TextCenter>
          </BoxCol>
        ),
        footer: (props) => props.column.id,
        pinPosition: "right",
        enableSorting: false,
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        footer: (props) => props.column.id,
        cell: (info) => {
          const status = info.getValue();
          return (
            <BoxCol>
              <TextCenter
                sx={(theme) => ({
                  fontWeight: 600,
                  color: getColorStatus(status, theme),
                })}
                width={"100%"}
              >
                {statusConfirmOption[status]?.label}
              </TextCenter>
            </BoxCol>
          );
        },
        width: isMiniWindow ? 50 : 150,
        minSize: isMiniWindow ? 50 : 150,
        enableSorting: false,
      },
    ].concat(listHeaderPlus);

    return cols;
  }, [listHeaderPlus, isMiniWindow]);
  return { columns };
};
export default useColumns;
